export const EmployeeContractVI = {
    "EmployeeContractAdd": {
        "EmployeeContractAdd": "Thêm hợp đồng",
        "EmployeeContractEdit": "Sửa hợp đồng",
        "EmployeeContractDelete": "Xoá hợp đồng",
        "ListEmployeeContract": "Danh sách hợp đồng",
        "LiquidationEmployeeContract": "Thanh lý hợp đồng",
        "ApprovalEmployeeContract": "Duyệt hợp đồng ",
        "QuickView": "Xem nhanh ",
        "undoApproval" : "Hoàn duyệt "
    },
    "EmployeeContractTitle": {
        "employeeContractId": "Mã HĐ",
        "fullName": "Tên Nhân Viên",
        "CurrentDepartment": "Phòng Ban ",
        "signDay": "Ngày Ký",
        "effectiveDate": "Hiệu lực từ ngày",
        "tillDate": "Đến ngày ",
        "Status": "Trạng thái ",
        "StatusQuo": "Tình trạng",
        "creator": "Người tạo ",
        "creatdate": "Ngày tạo ",
        "employeeId": " Nhân viên ",
        "contractId": "Loại hợp đồng ",
        "form": " Hình thức làm việc ",
        "position": " Vị trí",
        "office": " Chức vụ",
        "workplace": " Nơi làm việc",
        "signerId": "Người ký",
        "FIle": "Đính kèm ",
        "glone": "Ngạch lương",
        "to": " Đến ",
        "description": "Ghi chú",
        "informationSalary": "Thông tin lương và phụ cấp",
        "informationGeneral": "Thông tin chung",
        "notFound": "không có thông tin lương và phụ cấp",
        "approved": "Đã duyệt",
        "liquidated": " Thanh lý",
        "pending": "Chờ duyệt",
        "end": "Kết thúc",
        "Unsigned": "Chưa ký",
        "ineffect": "Đang hiệu lực",
        "expired": "Hết hiệu lực",
        "notyetvalid": "Chưa hiệu lực ",
        "status" : "Trạng thái",
        "contractName" : "Tên hợp đồng",
        "jobDetails" : "Công việc",
        "Working": "Đang làm việc",
        "Waiting" : "Chờ nhân việc",
        "DropTemp" : "Nghỉ tạm thời ",
        "Resignation" : "Nghỉ việc"
    },
    "placeholderEMC": {
        "employeeContractId": "Mã HĐ",
        "fullName": "Tên Nhân VIên",
        "CurrentDepartment": "Phòng Ban ",
        "signDay": "Ngày Ký",
        "effectiveDate": "Hiệu lực từ ngày",
        "tillDate": "Đến ngày ",
        "Status": "Trạng thái ",
        "creator": "Người tạo ",
        "creatdate": "Ngày tạo ",
        "employeeId": "Tìm với mã ,họtên ... ",
        "contractId": "Loại hợp đồng ",
        "form": " HÌnh thức",
        "position": " Vị trí",
        "office": " Chức vụ",
        "workplace": " Nơi làm việc",
        "signerId": "Tìm với mã ,họtên ... Người ký",
        "FIle": "Đính kèm ",
        "signerDay": "Từ ngày ",
        "glone": "Ngạch lương",
        "since": "Từ Ngày",
        "Note": "Ghi chú",
        "Salaryform": " Hình Thức Lương ",
        "Amountofmoney": " Số tiền ",
        "Allowance": "Phụ cấp"
    },
    "buttonEMC": {
        "buttonSubmit": "Tạo mới",
        "buttonUpdate": "Sửa",
        "buttonCancel": "Hủy Bỏ",
        "buttonKeep": "Giữ trang sau khi ",
        "buttonGo": "Chuyển đến danh sách sau khi ",
        "approve" : "Duyệt",
        "agree" : "Đồng ý"
    },
    "NotificationEmployeeContract": {
        "edit": "Sửa dữ liệu thành công...",
        "add": "Thêm dữ liệu thành công...",
        "delete": "Xóa dữ liệu thành công...",
        "Liquidation": "Cập nhật trạng thái thành công...",
        "question": " Bạn có muốn xóa không ? ",
        "questionApproval": "Bạn có muốn duyệt hợp đồng này không ? ",
        "approval": "Duyệt hợp đồng thành công....",
        "titleApproval": "Duyệt hợp đồng",
        "effectiveToSingDay": "Ngày ký không được lớn hơn ngày kết thúc hợp đồng",
        "effectiveToSince": "Lương và các khoản phụ cấp kể từ ngày hợp đồng không được lớn hơn ngày chấm dứt hợp đồng",
        "effectiveFromSince": "Lương và phụ cấp kể từ ngày không được thấp hơn ngày bắt đầu hợp đồng",
        "effectiveFromEffectiveTo": "Ngày hết hạn hợp đồng nhân viên sau ngày có hiệu lực",
        "salaryError": "Hình thức lương của ngày ",
        "salaryError1": " không được trùng nhau ",
        "AllowanceError": "Loại phụ cấp của ngày ",
        "updateSuccess" : "Đã cập nhật thành công...........",
        "startDate" : "Ngày bắt đầu ( ",
        "notJoinDate" : " ) không được nhỏ hơn Ngày bắt đầu làm việc ",
        "questionUndo" : "Bạn có muốn hoàn duyệt không? ",
    }
}